import { render, staticRenderFns } from "./SetPointButton.vue?vue&type=template&id=1c8389fe&scoped=true&"
import script from "./SetPointButton.vue?vue&type=script&lang=js&"
export * from "./SetPointButton.vue?vue&type=script&lang=js&"
import style0 from "./SetPointButton.vue?vue&type=style&index=0&id=1c8389fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8389fe",
  null
  
)

export default component.exports